import supabase from './supabase';
/**
 * 젭스 상수 그룹별 데이터 가져오기
 * 사용법
 * getGroupData('GROUP_KEY').then((res) => { console.log(res['ITEM_KEY']); });
 * @param query 그룹 키
 * @returns 그룹 키에 해당하는 아이템 키와 값
 */
export async function getGroupData(query: string) {
  try {
    // code_groups와 조인하여 조회
    const { data, error } = await supabase
      .from('code_groups')
      .select(
        `
          id,
          key,
          code_items!inner(key, value)
        `,
      )
      .eq('key', query);

    if (error) {
      console.error('Supabase 에러:', error);
      throw new Error(`데이터베이스 조회 실패: ${error.message}`);
    }

    // null 체크 추가
    if (!data || data.length === 0) {
      console.warn(`쿼리 '${query}'에 대한 데이터를 찾을 수 없습니다.`);
      return {};
    }

    if (data.length > 1) {
      console.warn(
        `쿼리 '${query}'에 대해 여러 결과가 발견되었습니다. 첫 번째 결과를 사용합니다.`,
      );
    }

    // 첫 번째 결과가 code_items 배열을 직접 가지고 있는지 확인
    const firstResult = data[0];

    // code_items가 직접 속성으로 있는 경우 (조인 쿼리 결과)
    if (firstResult.code_items && Array.isArray(firstResult.code_items)) {
      return Object.fromEntries(
        firstResult.code_items.map((item: { key: string; value: string }) => [
          item.key,
          item.value,
        ]),
      );
    }

    // 직접 key, value가 있는 경우 (code_items 테이블 직접 조회)
    if (firstResult.key && firstResult.value) {
      return Object.fromEntries(
        data.map((item: { key: string; value: string }) => [
          item.key,
          item.value,
        ]),
      );
    }

    console.warn('예상되지 않은 데이터 구조:', firstResult);
    return {};
  } catch (error) {
    console.error('getData 에러:', error);
    // 개발 중에는 빈 객체를 반환하여 앱이 계속 작동하도록 함
    return {};
  }
}
